/**
 * Tiny in-memory cache with TTL + in-flight dedupe.
 * Used by BadgeRow/TitleTag so 50-row leaderboards don't fire 100 parallel
 * GETs for the same handful of users (V2.5.2 perf audit).
 */
import api from "@/lib/api";

const TTL_MS = 60_000;
const stores = new Map();

function _store(key) {
  let s = stores.get(key);
  if (!s) { s = { cache: new Map(), inflight: new Map() }; stores.set(key, s); }
  return s;
}

export function fetchCached(storeKey, url) {
  const s = _store(storeKey);
  const now = Date.now();
  const hit = s.cache.get(url);
  if (hit && (now - hit.ts) < TTL_MS) return Promise.resolve(hit.value);
  const existing = s.inflight.get(url);
  if (existing) return existing;
  const p = api.get(url).then(r => {
    s.cache.set(url, { value: r.data, ts: Date.now() });
    s.inflight.delete(url);
    return r.data;
  }).catch(err => {
    s.inflight.delete(url);
    throw err;
  });
  s.inflight.set(url, p);
  return p;
}

export function invalidate(storeKey, urlPrefix) {
  const s = stores.get(storeKey);
  if (!s) return;
  for (const k of Array.from(s.cache.keys())) {
    if (!urlPrefix || k.startsWith(urlPrefix)) s.cache.delete(k);
  }
}
